import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { usersService } from '@/services/http/usersService'

export const useListFiltersRanking = () => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['listFiltersRanking'],
    queryFn: () => usersService.listFiltersRanking(),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar filtros do ranking',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    const { areas, campaigns } = data

    return {
      areas,
      campaigns,
      isLoading,
      refetchListFiltersRanking: refetch,
    }
  }

  return {
    areas: [],
    campaigns: [],
    isLoading,
    refetchListFiltersRanking: refetch,
  }
}
